import React, { useEffect, useState } from 'react'
import { useRequest } from 'ahooks';
import { queryRecord, updateRecord } from '../../../service/theme'
import useUrlSearch from '../../../utils/useUrlSearch';

export default function useService() {

    const [record, setRecord] = useState(0);
    const { getByKey } = useUrlSearch()

    //查看视频学习百分比进度
    const { run: recordQuery } = useRequest((params) => queryRecord(params), {
        manual: true,
        onSuccess: (res, param) => {
            console.log('query record', res)
            if (res.status) {
                if (res.data) {
                    setRecord(res.data)
                } else {
                    setRecord(0)
                }
            } else {
                setRecord(0)
            }
        }
    })

    // 更新学习记录
    const { run: recordUpdate } = useRequest((record) => updateRecord({
        videoId: getByKey('id'),
        record
    }), {
        manual: true,
        onSuccess: (res, param) => {
            // if(res.status){
            console.log('updateRecord', res)
            // }
        }
    })

    useEffect(() => {
        // 查询
        const videoId = getByKey('id')
        recordQuery({ videoId })
    }, [])

    return {
        record,
        recordQuery,
        recordUpdate
    }
}
